export default __webpack_public_path__ + "static/media/joel.fe986a7b.gif";